// calcolo della durata dei timeslot 

export const parseTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

export const getShiftDuration = (shift) => {
  const workStart = parseTime(shift.workStartTime);
  const workEnd = parseTime(shift.workEndTime);
  const totalMinutes = workEnd - workStart;

  const breakMinutes = shift.breaks?.reduce((sum, b) => {
    const start = parseTime(b.start_at);
    const end = parseTime(b.end_at);
    return sum + (end - start);
  }, 0) || 0;

  return (totalMinutes - breakMinutes) / 60;
};

export const getTotalWeeklyHours = (daysOfWeek, shiftsByDay) => {
  return daysOfWeek.reduce((total, day) => {
    const shifts = shiftsByDay[day] || [];
    const dayHours = shifts.reduce((sum, shift) => sum + getShiftDuration(shift), 0);
    return total + dayHours;
  }, 0);
};

export const getTimeSlotsDuration = (timeSlots) => {
  let totalMinutes = 0;

  timeSlots.forEach(slot => {
    const start = parseTime(slot.start_at);
    const end = parseTime(slot.end_at);
    let duration = end - start;

    const breakMinutes = slot.breaks?.reduce((sum, b) => {
      const bStart = parseTime(b.start_at);
      const bEnd = parseTime(b.end_at);
      return sum + (bEnd - bStart);
    }, 0) || 0;

    duration -= breakMinutes;
    totalMinutes += duration;
  });

  return totalMinutes / 60;
};

export const getTotalWeeklyHoursFromSlots = (slotsByDay) => {
  let totalMinutes = 0;

  slotsByDay.forEach((slot) => {
    if (!slot) return;

    if (Array.isArray(slot.time_slots)) {
      totalMinutes += slot.time_slots.reduce((sum, ts) => sum + (ts.duration || 0), 0);
    }

    if (slot.working_hour && Array.isArray(slot.working_hour.time_slots)) {
      totalMinutes += slot.working_hour.time_slots.reduce((sum, ts) => sum + (ts.duration || 0), 0);
    }
  });

  return (totalMinutes / 60);
};


export const formatHoursAndMinutes = (hoursDecimal) => {
  const totalMinutes = Math.round(hoursDecimal * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0 && minutes === 0) {
    return '0 min';
  } else if (hours === 0) {
    return `${minutes} min`;
  } else if (minutes === 0) {
    return `${hours} ore`;
  } else {
    return `${hours} ore, ${minutes} min`;
  }
};


export const getTotalWeeklyDurationFromDays = (slotsByDay) => {
  return slotsByDay.reduce((total, daySlot) => {
    if (daySlot?.duration && typeof daySlot.duration === 'number') {
      return total + daySlot.duration;
    }
    return total;
  }, 0) / 60;
};

